import React, { useEffect, useRef, useState } from "react";
import styles from "./ModalPoinerHome.module.scss";
import picture from "../../assets/artworkLanding/Cuadro_monas copy 10.png";
import { Carousel } from "react-bootstrap";
import MediaQuery from "react-responsive";
import CloseModalIcon from "../../components/icons/CloseModalIcon";
import SldierArrowRight from "../../components/icons/SldierArrowRight";
import RightArrowIcon from "../../components/icons/RigthArrowIcon";

const ModalPointerHome = ({ open, onClose }) => {
  const [index, setIndex] = useState(0);
  const totalSlides = 4; // Cambia esto según la cantidad real

  const handleNext = () => {
    const nextIndex = index + 1;
    setIndex(nextIndex >= totalSlides ? 0 : nextIndex);
  };
  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "80px",
          left: 0,
          height: "calc(100vh - 80px)",
          zIndex: 9,
          background: "#000000ef",
        }}
      >
        <div className={styles.close} onClick={onClose}>
          <CloseModalIcon />
        </div>
        <div className="picture pic-home d-flex justify-content-center align-items-center">
          <div className="box d-flex flex-column mt-5">
            <div
              style={{
                width: "100vw",
                overflow: "hidden",
                textAlign: "center",
              }}
            >
              <img src={picture} />
            </div>

            <Carousel
              touch={false}
              activeIndex={index}
              onSelect={setIndex}
              controls={false}
              indicators={false}
              slide={false}
              className={styles.carrouselArtPrint}
            >
              <Carousel.Item>
                <div className="bubble-container one">
                  <div className="bubble">
                    <small className="fw-bold text-light mb-2">
                      Fine Art Print
                    </small>
                    <br />
                    <small className="text-light">
                      Imagen fotográfica de 68,5 x 68,5 cm impresa en papel
                      Hahnemühle® Photo Rag UltraSmooth® de 300 g/m².
                    </small>
                  </div>
                  <div className="line"></div>
                  <div className="circle">
                    <span></span>
                  </div>
                </div>
              </Carousel.Item>

              <Carousel.Item>
                <div className="bubble-container two">
                  <div className="bubble">
                    <small className="fw-bold text-light mb-2">Marco</small>
                    <br />
                    <small className="text-light">
                      Marco blanco satinado estilo caja de 72,5 x 72,5,
                      realizado en madera Marupá con vidrio cristal.
                    </small>
                  </div>
                  <div className="line"></div>
                  <div className="circle">
                    <span></span>
                  </div>
                </div>
              </Carousel.Item>

              <Carousel.Item>
                <div className="bubble-container three">
                  <div className="bubble">
                    <small className="fw-bold text-light mb-2">
                      Certificado Tokenizado
                    </small>
                    <br />
                    <small className="text-light">
                      Certificado digital de autenticidad que valida la
                      propiedad y garantiza la unicidad de la obra.
                    </small>
                    <div className="line"></div>
                    <div className="circle">
                      <span></span>
                    </div>
                  </div>
                </div>
              </Carousel.Item>

              <Carousel.Item>
                <div className="bubble-container four">
                  <div className="circle">
                    <span></span>
                  </div>
                  <div className="line"></div>
                  <div className="bubble">
                    <small className="fw-bold text-light mb-2">Tag NFC</small>
                    <br />
                    <small className="text-light">
                      Acceso a contenido exclusivo sobre la obra via tecnología
                      contactless.
                    </small>
                  </div>
                </div>
              </Carousel.Item>
            </Carousel>
            <div className={styles.wrappButton}>
              <button
                onClick={handleNext}
                variant="primary"
                className={styles.buttonModalNext}
              >
                Siguiente <RightArrowIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalPointerHome;
